module.exports = __webpack_public_path__ + "img/t2-gray.3b39caf8.png";